export default __webpack_public_path__ + "static/media/svg.448d3aa8.svg";